module.exports = __webpack_public_path__ + "static/media/empty.6f5d4b37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty.jpg
// module id = 506
// module chunks = 0